import * as React from 'react';

import { ErrorBoundary } from 'src/components/ErrorBoundary';
import { ProjectDiagram } from 'src/containers/ProjectDiagram/ProjectDiagram';

export const ProjectWorkspace: React.VFC = () => {
  return (
    <div className="sd-project-workspace">
      <ErrorBoundary>
        <ProjectDiagram />
      </ErrorBoundary>
    </div>
  );
};
